import './productAttributeItem.scss';

import React from 'react';

type ProductAttributeItemProps = {
    label: string | React.ReactNode;
    children: React.ReactNode;
};

export default function ProductAttributeItem(props: ProductAttributeItemProps) {
    const { label, children } = props;

    return (
        <div className='product-attribute-item'>
            <div className='product-attribute-item-div product-attribute-title'>
                {label}
            </div>
            <div className='product-attribute-item-div product-attribute-value'>
                {children}
            </div>
        </div>
    );
}
